import { GameFullHouseProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFullHouseProperties";
/**
 * FullHousePortraitProperties.ts
 */
export class FullHousePortraitProperties extends GameFullHouseProperties {
    constructor() {
        super();
        this.position.set(512, 973);
    }
}
//# sourceMappingURL=FullHousePortraitProperties.js.map